import { pipe } from 'fp-ts/lib/function';
import * as A from 'fp-ts/Array';
import { iso } from 'newtype-ts';
import * as t from 'io-ts';
/*
For clients such as Newtech.
A complexProduct is not defined by its gift data but by the combination of options on a piece of fixtuur furniture.
*/
export const _ComplexProduct = t.record(t.string, t.union([t.string, t.number]));
const _ = iso();
export const fromOptions = (options) => {
    const filterOnlyProductAndOptions = (options) => {
        return Object.entries(options).filter(([name]) => name.includes('Option:') || name.includes('Product:Base'));
    };
    const flattenToOneValue = (options) => options.map(o => [o[0], o[1][0]]);
    return pipe(options, _.unwrap, filterOnlyProductAndOptions, flattenToOneValue, A.match(() => null, Object.fromEntries));
};
